import { Component, OnInit } from '@angular/core';
import { Config } from '../../_store';

@Component({
  selector: 'product-item-header-single',
  templateUrl: './product-item-header-single.component.html'
})
export class ProductItemHeaderSingleComponent implements OnInit {
  productHeader = Config.productItemHeading.single;
  constructor() { }
  ngOnInit() {}
}
